<template>
  <span>送信の前に、下記個人情報の取り扱いの注意点を必ずお読みになり、同意の上ご利用ください。</span>
  <div class="personal-info" v-html="personalInfo"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import personalInfo from '@/constants/consentForPersonalData'

/**
 * 個人情報説明
 */
export default defineComponent({
  name: 'PersonalInfo',
  setup() {
    return {
      personalInfo,
    }
  },
})
</script>

<style scoped>
.personal-info {
  min-height: 33px;
  padding: 5px 15px;
  line-height: normal;
  box-sizing: border-box;
  width: 100%;
  color: #606266;
  background-color: #fff;
  background-image: none;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>
